import { v4 as uuid } from 'uuid'
import map from '@/helpers/map'

export function parse (crop, images) {
  const { roots, bones } = crop
  return {
    ...crop,
    // FIXME: I've embedded this here to pass debug options to crop rendering
    // but maybe can be moved somewhere else.
    debug: {
      renderImageName: false,
      renderImageRect: false,
      renderCurrentBone: false,
      renderBone: false
    },
    roots: roots.map((root) => {
      return {
        ...root,
        id: uuid()
      }
    }),
    bones: bones.map((bone) => {
      return {
        ...bone,
        id: uuid(),
        currentStart: bone.start.slice(),
        currentEnd: bone.end.slice(),
        currentLength: bone.length,
        currentWidth: bone.width,
        currentOrientation: bone.orientation
      }
    }),
    images
  }
}

export function stringify ({ version, bones, images, numRoots, roots }) {
  return JSON.stringify({
    version,
    images: map.keysToArray(images),
    numRoots,
    roots: roots.map((root) => {
      return {
        name: root.name,
        numPoints: root.numPoints,
        BBCH: root.BBCH,
        length: root.length,
        angle: root.angle,
        bend: root.bend,
        noise: root.noise
      }
    }),
    bones: bones.map((bone) => {
      return {
        name: bone.name,
        start: bone.start,
        end: bone.end,
        parent: bone.parent,
        direction: bone.direction,
        orientation: bone.orientation,
        length: bone.length,
        width: bone.width,
        BBCH: bone.BBCH,
        flags: bone.flags,
        image: bone.image
      }
    })
  }, null, 2)
}

export default {
  parse,
  stringify
}
